import { Card } from '@/components/ui/card';

interface DiscordWidgetProps {
  serverId?: string;
  /** Tema do widget do Discord. O padrão é o escuro, como sempre foi. */
  tema?: 'dark' | 'light';
  /** Classes do cartão em volta (para o widget ocupar a altura de uma coluna, por exemplo). */
  className?: string;
  /** Classes de altura do widget; o padrão é 380 px no celular e 500 px a partir do tablet. */
  alturaClassName?: string;
}

export function DiscordWidget({ serverId, tema = 'dark', className = '', alturaClassName = 'h-[380px] md:h-[500px]' }: DiscordWidgetProps) {
  const safeServerId = serverId?.replace(/\D/g, '') ?? '';

  if (!safeServerId) {
    return null;
  }

  return (
    <Card className={`bg-card border-border overflow-hidden p-0 ${className}`}>
      <iframe
        src={`https://discord.com/widget?id=${safeServerId}&theme=${tema === 'light' ? 'light' : 'dark'}`}
        width="100%"
        allowTransparency={true}
        frameBorder="0"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
        // 500 px fixos viravam um bloco da altura da tela no celular.
        className={`w-full rounded-lg ${alturaClassName}`}
        title="Discord Widget"
      />
    </Card>
  );
}

export default DiscordWidget;
